import { defineMessages } from 'react-intl';

export const messages: {
	hideFromSidebarSectionScreenReader: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	primaryNavigationSectionScreenReader: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	shortcutsSectionScreenReader: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	showInSidebarSectionScreenReader: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	primaryNavigationSectionScreenReader: {
		id: 'navigation.global-side-navigation.primary-navigation-section-screen-reader',
		description:
			'Section label used to describe the primary navigation section for screen reader users.',
		defaultMessage: 'Dragging {item} over primary navigation group',
	},
	shortcutsSectionScreenReader: {
		id: 'navigation.global-side-navigation.shortcuts-section-screen-reader',
		description: 'Section label used to describe the shortcuts section for screen reader users.',
		defaultMessage: 'Dragging {item} over shortcuts group',
	},
	hideFromSidebarSectionScreenReader: {
		id: 'navigation.global-side-navigation.hide-from-sidebar-section-screen-reader',
		description:
			'Section label used to describe the hide from sidebar button for screen reader users.',
		defaultMessage: 'Dragging {item} over "Hide from navigation" drop area',
	},
	showInSidebarSectionScreenReader: {
		id: 'navigation.global-side-navigation.show-in-sidebar-section-screen-reader',
		description:
			'Section label used to describe the show in sidebar button for screen reader users.',
		defaultMessage: 'Dragging {item} over "Show in navigation" drop area',
	},
});

/**
 * Error-boundary messages for the side-nav main nav item.
 *
 * NOTE: This file currently only exists to seed the translation pipeline. The runtime
 * code still uses the equivalent strings from
 * `@atlassian/navigation-error-boundary` (see `sideNavMainItemMessages` in
 * `get-messages-for-location/messages.ts`). Once translations land, a follow-up
 * changeset will integrate these messages into the UI and remove the legacy copy.
 *
 * See https://hello.jira.atlassian.cloud/browse/NAVX-4866
 */
export const mainNavItemMessages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	header: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	header: {
		id: 'navigation.global-side-navigation.main-nav-item.error.header',
		defaultMessage: 'We couldn’t load the item {menuId}',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.global-side-navigation.main-nav-item.error.description',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});

export const defaultErrorMessages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	header: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	header: {
		id: 'navigation.global-side-navigation.error.header.default',
		defaultMessage: 'We couldn’t load this content',
		description: 'Header when an unknown error occurs',
	},
	description: {
		id: 'navigation.global-side-navigation.error.description.default',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
});
